import React from 'react'
import Requirement from "./Requirement";



function Requirements({ long, number }){
    return (
        <section className="strength-meter">
            <span className='requirement__title'>Password Requirements</span>
            <Requirement
            htmlFor="password"
            isvalid={long}
            invalidMessage="We love long passwords, use at least 8 characters if you can."
            validMessage="Sweet, that's long enough for us!"
            />
            <Requirement
            htmlFor="password"
            isvalid={number}
            invalidMessage=" Make it tricky to guess, make it more secure, adding a number, uppercase, lowercase, and a special character is recommended."
            validMessage="Nice, now you're safer than the average"
            />
    </section>
    )
}

export default Requirements

